/* @flow */
import { Map } from 'immutable';

type State = Map<string, number>;
export const initialState: State = new Map();

/*
 * A store that keeps track of the read marker push events.
 * This store should be be relied upon to know if a message was read or not!
 * This store exist to override stream items read summary state
 *
 */
export default function reducer(state: State = initialState, action: *): State {
  switch (action.type) {
    case 'changeset-update-chat_marker':
      action.changes.forEach(change => {
        state = state.set(change.uuid, change.content.markers.read_seq);
      });

      return state;
    default:
      return state;
  }
}
